import { useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { signOut } from '../../store/actions/auth';
import { AppContext } from '../../providers/AppProvider';

const LogOut = () => {
  const { setProgress } = useContext(AppContext);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    localStorage.removeItem('theme');
    dispatch(signOut());
    setProgress([]);
    history.push('/sign-in');
  }, []);

  return null;
};

export default LogOut;
